import billboardImg from '../images/billboard-image.jpg'
import ContainerPadded from './ContainerPadded';

export default function Home() {
  const billboardImageHeightPixels = 400;

  return (<>
    <div style={{ position: "relative" }}>
      <img src={billboardImg}
        alt=""
        style={{
          "objectFit": "cover",
          "width": "100%",
          "height": billboardImageHeightPixels,
          "position": "relative",
          "objectPosition": "0% 57%"
        }} />
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: billboardImageHeightPixels,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}>
        <div className='d-flex align-items-center' style={{ height: billboardImageHeightPixels, fontFamily: "'Titillium Web', sans-serif" }}>
          <div className='col' />
          <div className='col align-middle text-light'>
            <h1 className='text-light fw-bolder'>Revell Logistics Solutions</h1>
            <p>Your trusted partner in logistics</p>
          </div>
        </div>
      </div>
    </div>
    <ContainerPadded>
      <div className='row'>
        <div className='col'>
          <h1>
            <i className='bi bi-list-task me-3' />
            Services
          </h1>
          <p>
            Revell Logistics Solutions is a full service logistics company that provides a wide range of services to meet all of your shipping needs. We are a family owned and operated business that has been in the industry for over 20 years. We pride ourselves on providing the best customer service in the industry. We are available 24/7 to answer any questions you may have. We look forward to working with you!
          </p>
        </div>
        <div className='col'>
          <h1>
            <i className='bi bi-clipboard2-data me-3' />
            Request a Quote
          </h1>
          <p>Use this tool to request a quote for your shipment.</p>
        </div>
        <div className='col'>
          <h1>
            <i className='bi bi-binoculars-fill me-3' />
            Track Shipment
          </h1>
          <p>Use this tool to track your shipment.</p>
        </div>
      </div>
    </ContainerPadded>
  </>);
}

